import CancelIcon from "@mui/icons-material/Cancel";
import { Backdrop, Paper, Slide, StyledEngineProvider, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import React from "react";
import { TouchableOpacity, View } from "react-native";
import { Button } from "react-native-elements";
import { FONT_FAMILY, THEME_COLORS } from "../../themes";

interface ModalV3Props extends React.HTMLProps<Element> {
  visible: boolean;
  header: string;
  subheader?: string;
  subheaderComponent?: JSX.Element;
  onCancel?: () => void;
  onConfirm?: () => void;
  onClose?: () => void;
  disabledConfirm?: boolean;
  disabledCancel?: boolean;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

function ModalV3({
  visible,
  header,
  subheader,
  subheaderComponent,
  onClose,
  children,
  onConfirm,
  onCancel,
  disabledConfirm,
  disabledCancel,
  cancelButtonText,
  confirmButtonText,
  width,
}: ModalV3Props) {
  const { classes } = useStyles();

  return (
    <Backdrop open={!!visible} className={classes.backdrop}>
      <Slide direction="left" in={!!visible} mountOnEnter unmountOnExit>
        <Paper elevation={4} className={classes.paper} style={{ width: width ?? "calc(50vw)" }}>
          <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
            <div>
              <Typography className={classes.header}>{header}</Typography>
              {subheader && <Typography className={classes.subheader}>{subheader}</Typography>}
              {subheaderComponent}
            </div>

            {onClose && (
              <TouchableOpacity onPress={onClose}>
                <CancelIcon style={{ color: THEME_COLORS.grey1, fontSize: 36 }} />
              </TouchableOpacity>
            )}

            {onCancel && onConfirm && (
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <Button
                  title={cancelButtonText ?? "Cancel"}
                  onPress={onCancel}
                  type="clear"
                  disabled={disabledCancel}
                  titleStyle={{ color: THEME_COLORS.purple, fontSize: 15, marginRight: 12 }}
                />
                <Button
                  title={confirmButtonText ?? "Save Changes"}
                  onPress={onConfirm}
                  disabled={disabledConfirm}
                  titleStyle={{ color: THEME_COLORS.white, fontSize: 15 }}
                  disabledStyle={{ backgroundColor: "#A166C866" }}
                  disabledTitleStyle={{ color: THEME_COLORS.white }}
                  buttonStyle={{ backgroundColor: THEME_COLORS.purple, borderWidth: 0, padding: 16 }}
                />
              </View>
            )}
          </View>

          {children}
        </Paper>
      </Slide>
    </Backdrop>
  );
}

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    width: 100 + theme.spacing(2),
  },
  paper: {
    position: "absolute",
    height: "calc(100% - 64px)",
    right: 0,
    borderRadius: "1em",
    borderBottomRightRadius: 0,
    borderTopRightRadius: 0,
    padding: "2em",
  },
  backdrop: {
    zIndex: 9999999,
    // position: "relative",
  },
  header: {
    fontSize: "1.5em",
    fontFamily: FONT_FAMILY.semiBoldV3,
  },
  subheader: {
    fontSize: "1em",
    color: THEME_COLORS.sideMenuGrey,
  },
}));

export default ModalV3;
